export const portfolioData = [
  {
    cover: require('../../portfolio/St.-Vincent-de-Paul-logo.jpeg'),
    title: 'St Vincent De Paul San Francisco',
    description:
    'Program Data Analyst helping maintain, verify and clean data for all of San Francisco',
    stack: 'Saleforce, Clarity, BitFocus, Python, ',
    url: 'https://svdp-sf.org/',
  },
  {
    cover: require('../../portfolio/rently.jpg'),
    title: 'Rently',
    description:
    'Fintech company in Singapore',
    stack: 'Fullstack, Android, Apple, Mobile',
    url: 'https://www.rently.sg/',
  },
  
  {
    cover: require('../../portfolio/My project.jpg'),
    title: 'Lookout!',
    description:
      'A full stack scavenger hunt application for freshmen college students',
    stack: 'React Native, MongoDB, Expo, NodeJS',
    url: 'https://play.google.com/store/apps/details?id=com.Lookout',
    src: 'https://github.com/jritter77/ScavengerHunt',
  },
  {
    cover: require('../../portfolio/images.jpg'),
    title: 'Jordan Urbany Photography Website',
    description: 'My personal website for a one of my hobbies photography.',
    stack: 'ReactJS, JSX',
    url: 'https://www.jordanurbanyphotography.com/',
    src: 'https://github.com/jordanurbany/Photography',
  },

  {
    cover: require('../../portfolio/download.jpg'),
    title: 'Ovvy Digital Marketplace',
    description:
      'The Peoples Marketplace, an app which is a digital marketplace where consumers can find, compare and book local services',
    stack: 'Fullstack, Android, Apple, Mobile',
    url: 'https://ovvyapp.com/',
  },
]
